









import { Component, Vue, Prop } from 'vue-property-decorator'
import { List } from 'vant'
import selfSonItem from './selfSonItem.vue'

@Component({
  components: {
    [List.name]: List,
    selfSonItem
  }
})
export default class selfSonSelect extends Vue {
  @Prop({ default: () => [] }) readonly selfsonlist!: any
}
